import { Country } from '../data/countries/useCountries';

/**
 * Convert ISO country codes to country names for matching against Shopify variants
 */

// Hard-coded mappings for edge cases where the API name doesn't match Shopify variant names
const ISO_TO_COUNTRY_NAME_MAPPING: Record<string, string> = {
  KR: 'South Korea',
  // Add more mappings as needed for cases where API country name doesn't match Shopify variant name
};

/**
 * Converts ISO country codes to country names for matching against Shopify variants
 * @param isoCode - The ISO country code (e.g., "NP", "IN", "KR")
 * @param countries - Optional countries array from the API. If provided, will use this for lookup.
 * @returns The country name that matches Shopify variant names
 */
export function convertIsoToCountryName(isoCode: string, countries?: Country[]): string {
  // First check hard-coded mappings for edge cases
  if (ISO_TO_COUNTRY_NAME_MAPPING[isoCode]) {
    return ISO_TO_COUNTRY_NAME_MAPPING[isoCode];
  }

  // If countries array is provided, look up by ISO code
  if (countries && countries.length > 0) {
    const foundCountry = countries.find(country => country.code === isoCode);
    if (foundCountry) {
      return foundCountry.name;
    }
  }

  // Fall back to original value if no mapping found
  return isoCode;
}
